import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import islands from '@constants/islands'
import convertToBase64 from '@helpers/file-to-base64'

export default class ElectricalPermit extends React.Component {
  resource = '/electrical_permits'
  form_key = 'electrical_permit'
  defaults = {}

  // Delete lines as needed
  // fee = 99
  free = true
  // postpaid = true
  skip_location = true
  hide_buttons = false
  custom_actions = []


  validate = async form => {
    const update = {}

    let index = 0

    if(form.drawing_upload[0]) {
      update.drawing_upload = []

      for (let row of form.drawing_upload) {
        const {
          file_upload,
          ...item
        } = row
        index ++

        if(file_upload){
          item.file_upload = await convertToBase64(file_upload);
          item.title = `Drawing - ${index}`;
          item.desc = `Drawing - ${index}`;
          update.drawing_upload.push(item);
        }
      }
  }

    return update
  }

  foremost = null


  fields = form => [
    {
      // Auto-generated on form creation, prefix E0000001
      name: 'specification_number',
      label: 'Specification No.',
      hide: true,
      view: true,
    },
    {
      name: 'permit_type',
      label: 'Licence Type',
      options: ['Single Phase', 'Three Phase']
    },
    {
      name: 'building_permit_numb',
      label: 'Building Permit number',
    },
    {
      name: 'building_lot_number',
      label: 'Building Lot No.',
    },

    '::Property Owner',
    {
      name: 'property_owner',
      label: 'I am the Property Owner',
      type: 'select:bool',
    },
    {
      name: 'i_am',
      label: 'I am the...',
      options: ['electrician', 'agent'],
      hide: form.property_owner,
    },
    {
      name: 'property_owner_first_name',
      label: 'First Name',
      hide: form.property_owner,
    },
    {
      name: 'property_owner_last_name',
      label: 'Last Name',
      hide: form.property_owner,
    },

    '::Property information',
    {
      name: 'building_island',
      label: 'Island',
      options: islands,
    },
    {
      name: 'building_po_box',
      label: 'P.O. Box',
    },
    {
      name: 'building_address',
      label: 'Address',
    },
    {
      name: 'total_floor_area',
      label: 'Total Floor Area',
    },
    {
      name: 'sq_ft',
      label: 'SQ. FT.',
      type: 'integer',
    },

    '::Supply Required',
    {
      name: 'solar_powered',
      label: 'Is the building solar powered?',
      type: 'select:bool',
    },
    {
      name: 'solar_type',
      label: 'Type of Solar',
      options: [
        'Grid Tied',
        'Off Grid',
        'Hybrid',
      ],
      hide: !form.solar_powered,
    },
    {
      name: 'type_of_occupancy',
      label: 'Type of Occupancy',
      options: [
        'Residential',
        'Multi-Family (3 or less units)',
        'Multi-Family (4 or more units)',
        'Commercial',
        'Industrial'
      ],
      hint: 'There will be additional fees for multi-family, commercial and industrial',
    },
    {
      name: 'supply_req',
      label: 'Supply Required',
      options: [
        'Overhead',
        'Underground',
      ],
    },
    {
      name: 'supply_req_wires',
      label: 'Supply Required (Wires)',
      options: [
        '2-wires',
        '3-wires',
        '4-wires',
      ],
    },
    {
      name: 'voltage',
      label: 'Voltage',
      options: [
        '120/208',
        '120/240',
        '240/416',
        '254/440',
        '266/460',
        '277/480',
      ],
    },
    {
      name: 'max_demand',
      label: 'Max. Demand',
      type: 'integer',
      hint: 'KVA'
    },
    {
      name: 'main_switch_size',
      label: 'Size of Main Switch',
      type: 'integer',
      hint: 'AMPS'
    },
    {
      name: 'submain_switch',
      label: 'Is there a Sub-Main Switch?',
      type: 'select:bool',
    },
    {
      name: 'submain_switch_size',
      label: 'Size of Sub-Main Switch',
      type: 'integer',
      hint: 'AMPS',
      hide: !form.submain_switch
    },
    {
      name: 'service_conduit_size',
      label: 'Size of Service Conduit',
      type: 'integer',
      hint: 'Inches',
    },
    {
      name: 'circuits_number',
      label: 'No. of Circuits',
      type: 'integer'
      // hint: ''
    },
    {
      name: 'service_conductors_list',
      label: 'Service Conductors (Size and Insulation)',
      rowLabel: 'Conductors',
      fields: [
        { name: 'size', label: 'Size', type: 'integer' },
        { name: 'insulation', label: 'Insulation' },
      ],
    },
    {
      name: 'proposed_wiring_system',
      label: 'Proposed Wiring System',
      // type: 'integer'
      // hint: ''
    },
    '::Details of Load',
    {
      name: 'lighting',
      label: 'Lighting',
      type: 'integer',
      hint: 'KW',
    },
    {
      name: 'water_heater',
      label: 'Water Heater',
      type: 'integer',
      hint: 'KW',
    },
    {
      name: 'range',
      label: 'Range(s)',
      type: 'integer',
      hint: 'KW',
    },
    {
      name: 'other_load_list',
      label: 'Other',
      required: false,
      hint: 'KW',
      fields: [
        { name: 'purpose', label: 'Purpose' },
        { name: 'voltage', label: 'Voltage', type: 'integer' },
      ],
    },
    {
      name: 'motors_list',
      label: 'Motors',
      required: false,
      rowLabel: 'Motors',
      fields: [
        { name: 'number', label: 'No.', type: 'integer' },
        { name: 'purpose', label: 'Purpose' },
        { name: 'voltage', label: 'Voltage', type: 'integer' },
        { name: 'horse_power', label: 'H. P.', type: 'integer' },
        { name: 'phase', label: 'Phase' },
      ],
    },
    // '::Site Inspection Date',
    // {
    //   name: 'inspection_date',
    //   label: 'Inspection Date',
    //   type: 'date',
    // },

    '::SPACER',
    "::Uploads",
    {
      heading: '<b>Please upload all relevant drawings.</br>'
    },
    {
      name: 'drawing_upload',
      label: 'Drawing Upload',
      hint: 'Please upload all relevant drawings.',
      view: false,
      fields: [
        {
          name: 'file_upload',
          type: 'file:all',
        },
      ],
      max: 10,
    },
    // {
    //   name: 'drawing_upload',
    //   type: 'file:all',
    //   required: false,
    // },
    // {
    //   name: 'drawing_two_upload',
    //   type: 'file:all',
    //   required: false,
    // },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
